<div class="container-fluid">
  <header>
    <app-nav-menu></app-nav-menu>
  </header>

  <main role="main" class="backg">
    <div class="container-fluid ">
      <div class="row">
        <div class="col-sm-12 col-md-6 left_content">
          <div class="left_con">
            <h2 class=" welcome1message">Welcome to PATEMPO!</h2>
            <p class="mt-4 text-left text-secondary welcome2message">PATEMPO™ responds to a critical question that any patent applicant or agent has: “Assuming I can obtain a patent, how long will it take to get granted?”. It allows to automatically estimate the pendency of your patent applications in China and South-East Asia and to instantly access to our recommendations on how to expedite their examination, publication and grant.</p>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 right_content">
          <div class="right_con">
            <form [formGroup]="service.formModel" autocomplete="off" (submit)="onSubmit()">
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="ball-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
              <div class="row">
                <div class="col-12 text-left ">
                  <h3 class="text-secondary loginTitle"><strong>Create an Account</strong></h3>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="mb-1 mt-4">
                    <h6 class="mb-0 text-sm">First Name</h6>
                  </label>
                  <input formControlName="FirstName" class="firstName" placeholder="First Name">
                  <label class="text-danger" *ngIf="service.formModel.get('FirstName').touched && service.formModel.get('FirstName').errors?.required">
                    <i>required</i>
                  </label>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="mb-1 mt-4 lastNameLabel">
                    <h6 class="mb-0 text-sm">Last Name</h6>
                  </label>
                  <input formControlName="LastName" class="lastName" placeholder="Last Name">
                  <label class="text-danger" *ngIf="service.formModel.get('LastName').touched && service.formModel.get('LastName').errors?.required">
                    <i>required</i>
                  </label>
                </div>
              </div>
              <div class="row px-3 mb-3">
                <label class="mb-1">
                  <h6 class="mb-0 text-sm">Organization Name</h6>
                </label>
                <input formControlName="OrgName" class="orgName" placeholder="Organization Name">
                <label class="text-danger" *ngIf="service.formModel.get('OrgName').touched && service.formModel.get('OrgName').errors?.required">
                  <i>required</i>
                </label>
              </div>
              <div class="row px-3 mb-3">
                <label class="mb-1">
                  <h6 class="mb-0 text-sm">Email Address</h6>
                </label>
                <input formControlName="Email" class="emailAddress" placeholder="Email Address">
                <label class="text-danger" *ngIf="service.formModel.get('Email').touched && service.formModel.get('Email').errors?.email">
                  <i>required</i>
                </label>
              </div>
              <div formGroupName="Passwords">
                <div class="row px-3 mb-3">
                  <label class="mb-0"><h6 class="text-sm">Password</h6></label>
                  <input type="password" class="password" formControlName="Password" autocomplete="off" placeholder="Password">
                  <label class="text-danger" *ngIf="service.formModel.get('Passwords.Password').touched && service.formModel.get('Passwords.Password').errors?.required">
                    <i>required</i>
                  </label>
                  <label class="text-danger" *ngIf="service.formModel.get('Passwords.Password').touched && service.formModel.get('Passwords.Password').errors?.minlength">
                    <i> Minimum 4 characters required.</i>
                  </label>
                </div>
                <div class="row px-3">
                  <label class="mb-0"><h6 class="text-sm">Confirm Password</h6></label>
                  <input type="password" class="confirmPassword" formControlName="ConfirmPassword" autocomplete="off" placeholder="Confirm Password">
                  <label class="text-danger" *ngIf="service.formModel.get('Passwords.ConfirmPassword').touched && service.formModel.get('Passwords.ConfirmPassword').errors?.required">
                    <i>required</i>
                  </label>
                  <label class="text-danger" *ngIf="service.formModel.get('Passwords.ConfirmPassword').touched && service.formModel.get('Passwords.ConfirmPassword').errors?.passwordMismatch">
                    <i>Confirm Password does not match.</i>
                  </label>
                </div>
              </div>
              <div class="row px-3 mb-3">

              </div>
              <div class="row mb-3 px-3 mt-4"> <button type="submit" class="text-center w-100 btn-login text-white register-button" [disabled]="!service.formModel.valid">SIGN UP</button> </div>
              <div class="col-12 mt-4 mb-3  text-center text_dont reminderMessageContent" align="center">
                Already have an account? <a class="sign-up" [routerLink]="['/login']">LOGIN</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>

  <div class="LoginFooter">
    <footer>
      <patempoFooter></patempoFooter>
    </footer>
  </div>

</div>


